class APIS {
	apis() {
		return {
			elevenLabsAgentCreate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/elevenlabs/agent/add'
			},
			elevenLabsAgentGetAll: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/elevenlabs/agent/all'
			},
			elevenLabsAgentGetAgentById: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/elevenlabs/agent/detail'
			},
			elevenLabsAgentUpdateAgent: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/elevenlabs/agent/update'
			},
			elevenLabsAgentSetAgentActive: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/elevenlabs/agent/set-active'
			},
			elevenLabsAgentDeleteAgent: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/elevenlabs/agent/delete'
			}
		};
	}
}

export default new APIS();
